import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SingleSelect from '../../../input_filed/SingleSelect';
import SaveButton from '../../../buttons/SaveButton';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Text from '../../../input_filed/Text';
import { reasonSchema } from './ValidationSchema';
import { updateReasonTodo } from '../../../../redux/slices/master/reason/UpdateReason';

export default function UpdateReasonForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { state } = useLocation()
    const [spiner, setSpiner] = useState(false)

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const initiaValues = {
        reason_name: state?.reason_name || '',
        status: state?.status || '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, setValues } = useFormik({
        initialValues: initiaValues,
        validationSchema: reasonSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setSpiner(true)
            dispatch(updateReasonTodo({ ...values, id: state?._id })).then((res) => reason_res(res))
        }
    })

    useEffect(() => {
        setValues({
            reason_name: state?.reason_name || '',
            status: state?.status || '',
        })
    }, [state])

    const reason_res = (res) => {
        if (res?.payload?.status == 200) {

            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/reason-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.messagea?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <div className='main_layout'>
                    <div className='layout_head mb-3'>
                        <h5>Update Reason</h5>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4'>
                            <Text
                                label_name='Reason'
                                name='reason_name'
                                value={values.reason_name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.reason_name && touched.reason_name && <span className='text-danger form_label'>{errors.reason_name}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <SingleSelect
                                label_name='Status'
                                option={status_option}
                                name='status'
                                onChange={(e) => setFieldValue('status', e.value)}
                                onBlur={handleBlur}
                                defaultValue={status_option?.find((option) => option.value === values.status)}
                                error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                            />
                        </div>
                        <div className='d-flex justify-content-end mt-2'>
                            <SaveButton
                                spiner={spiner}
                                name={'UPDATE'}
                            />
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}


